import { Component } from "react";
import { FlatList, Pressable, View } from "react-native";
import ComicItem from "../common/ComicItem";
import { CommonStyles } from '../common/CommonStyle';
import ListFooter from "../common/ListFooter";
import { windowWidth } from "../common/Platform";
import FastImage from "../components/FastImage";
import px from "../utils/px";
import { comics } from "../utils/ResourceHelper";
import StringUtils from "../utils/StringUtils";
export default class ComicNew extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            showFoot: 0,
            isRefreshing: false
        }

        this.totalPages = 0;
        this.currPage = 1;
        this.videoRefs = [];
        this.moveOffset = 0;
    }


    componentDidMount() {
        this._loadData()
    }

    _loadData = async () => {
        const { data, totalPages } = await comics({ key: this.props.tag.source, page: this.currPage });
        this.setState({
            data: this.state.data.concat(data),
            showFoot: totalPages > this.currPage ? 0 : 1,
            isRefreshing: false
        });
    }

    _renderItem = ({ item, index }) => {
        if (index % 10 == 1) {
            const banner = this.props.tag.banner[Math.floor(index / 11) % this.props.tag.banner.length];
            return (
                <Pressable onPress={() => {
                    StringUtils.click(banner.url)
                }}>
                    <FastImage
                        url={banner.image}
                        style={{
                            width: windowWidth,
                            height: (banner.height / banner.width) * windowWidth,
                            marginBottom: px(10)
                        }}
                    />
                </Pressable>
            )
        }
        item.id = item.id.toUpperCase();
        return (
            <ComicItem item={item} width={windowWidth} height={windowWidth * 9 / 16} resizeMode={'cover'} />
        )

    };


    /**标签下拉刷新 */
    _onRefresh = () => {
        if (!this.state.isRefreshing) {
            this.setState({
                isRefreshing: false,
            })
        }
    }
    /**标签上滑刷新 */
    _onEndReached = () => {
        if (this.state.showFoot != 0) {
            return;
        }
        this.currPage++;
        this.setState({ showFoot: 2 }, () => {
            this._loadData();
        });

    };

    render() {
        return (
            <View style={CommonStyles.body}>
                <FlatList
                    ref={ref => (this._list = ref)}
                    keyExtractor={item => item.id}
                    data={this.state.data}
                    style={{ flex: 1 }}
                    contentContainerStyle={{ alignItems: 'center' }}
                    renderItem={this._renderItem}
                    onScroll={(e) => {
                        const { contentOffset: { y }, layoutMeasurement: viewSize } = e.nativeEvent;
                        if (Math.abs(y - this.moveOffset) >= 10) {
                            this.moveOffset = y;
                            this.videoRefs.forEach(i => { i && i._onScroll(); });
                        }
                    }}
                    initialNumToRender={4}
                    windowSize={4}
                    numColumns={1}
                    refreshing={this.state.isRefreshing}
                    showsVerticalScrollIndicator={false}
                    ListFooterComponent={() => <ListFooter showFoot={this.state.showFoot} page={this.currPage} />}
                    onRefresh={this._onRefresh}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={0.1}
                />
            </View>
        )
    }
}